(() => {
  'use strict';

  if (window._samSwatchesScriptInitialized) return;
  window._samSwatchesScriptInitialized = true;

  const PROCESSED_SWATCH_ATTR = 'data-sam-swatches-processed';
  const LISTENER_ATTR = 'data-sam-swatches-listener';

  init();

  function init() {
    overrideVariantPicker();
    runWhenReady(() => initializeSwatches(document));
    observeNewSwatches();
    document.addEventListener('shopify:section:load', handleShopifySectionEvent);
    document.addEventListener('shopify:section:select', handleShopifySectionEvent);
    document.addEventListener('shopify:block:select', handleShopifySectionEvent);
  }

  function handleShopifySectionEvent(event) {
    if (event?.target instanceof Element) {
      initializeSwatches(event.target);
    }
  }

  function runWhenReady(callback) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', callback, { once: true });
    } else {
      callback();
    }
  }

  function observeNewSwatches() {
    const observer = new MutationObserver((mutations) => {
      for (const mutation of mutations) {
        for (const node of mutation.addedNodes) {
          if (!(node instanceof Element)) continue;
          initializeSwatches(node);
        }
      }
    });

    observer.observe(document.documentElement, { childList: true, subtree: true });
  }

  function initializeSwatches(root) {
    const elements =
      root instanceof Element
        ? root.matches('product-swatches')
          ? [root]
          : Array.from(root.querySelectorAll('product-swatches'))
        : Array.from(document.querySelectorAll('product-swatches'));

    elements.forEach((swatchElement) => {
      if (swatchElement.hasAttribute(PROCESSED_SWATCH_ATTR)) return;
      swatchElement.setAttribute(PROCESSED_SWATCH_ATTR, 'true');

      const productCard = swatchElement.closest('product-card');
      if (!productCard) return;

      attachVariantUpdateHandler(productCard);
    });
  }

  function attachVariantUpdateHandler(productCard) {
    const cardGallery = productCard.querySelector('.card-gallery');
    const hasDefaultSize = cardGallery?.dataset.defaultSize;
    if (!hasDefaultSize) return;

    if (productCard.hasAttribute(LISTENER_ATTR)) return;
    productCard.setAttribute(LISTENER_ATTR, 'true');

    productCard.addEventListener(
      'variant:update',
      (event) => {
        const selectedInput = productCard.querySelector('input[type="radio"]:checked[data-variant-id]');
        if (!selectedInput) return;

        const selectedVariantId = selectedInput.dataset.variantId;
        const selectedMediaId = selectedInput.dataset.optionMediaId;
        const eventHtml = event?.detail?.data?.html;
        if (!eventHtml) return;

        const anchorElement = eventHtml.querySelector('product-card a');
        if (anchorElement instanceof HTMLAnchorElement && selectedVariantId) {
          const url = new URL(anchorElement.href, window.location.origin);
          url.searchParams.set('variant', selectedVariantId);
          anchorElement.href = url.toString();
        }

        const productCardLinkElement = eventHtml.querySelector('product-card-link');
        if (productCardLinkElement && selectedMediaId) {
          const mediaElement = productCard.querySelector(`[data-media-id="${selectedMediaId}"]`);
          const img = mediaElement?.querySelector('img');

          if (img?.src) {
            const mediaUrl = img.src.replace(/(\.[^.]+)$/, '_500x$1');
            productCardLinkElement.setAttribute('data-featured-media-url', mediaUrl);
          }
        }
      },
      true
    );
  }

  function overrideVariantPicker() {
    if (window._samVariantPickerInitialized) return;
    window._samVariantPickerInitialized = true;

    waitForVariantPicker().then(() => {
      const VariantPickerClass = customElements.get('swatches-variant-picker-component');
      if (!VariantPickerClass || VariantPickerClass.prototype._samUpdateVariantPickerOriginal) return;

      const originalUpdate = VariantPickerClass.prototype.updateVariantPicker;
      VariantPickerClass.prototype._samUpdateVariantPickerOriginal = originalUpdate;

      VariantPickerClass.prototype.updateVariantPicker = function updateVariantPicker(newHtml) {
        let newProduct;
        const newVariantPickerSource = newHtml.querySelector(this.tagName.toLowerCase());

        if (!newVariantPickerSource) {
          throw new Error('No new variant picker source found');
        }

        if (newVariantPickerSource instanceof HTMLElement) {
          const { productId: newProductId, productUrl: newProductUrl } = newVariantPickerSource.dataset;

          if (newProductId && newProductUrl && this.dataset.productId !== newProductId) {
            newProduct = { id: newProductId, url: newProductUrl };
          }

          this.dataset.productId = newProductId || '';
          this.dataset.productUrl = newProductUrl || '';
        }

        const parentCard = this.closest('product-card');
        const cardGallery = parentCard?.querySelector('.card-gallery');
        const hasDefaultSize = cardGallery?.dataset.defaultSize;

        if (hasDefaultSize) {
          return newProduct;
        }

        return this._samUpdateVariantPickerOriginal(newHtml);
      };
    });
  }

  function waitForVariantPicker() {
    return new Promise((resolve) => {
      if (customElements.get('swatches-variant-picker-component')) {
        resolve();
        return;
      }

      const interval = setInterval(() => {
        if (customElements.get('swatches-variant-picker-component')) {
          clearInterval(interval);
          resolve();
        }
      }, 100);
    });
  }
})();
